import { Section } from '../components/Section/Section'
import { Metric } from '../components/Metric/Metric'
import { useAnalyticsContext } from '../AnalyticsContext'

export const GrowthAndDiscovery = () => {
  const { period } = useAnalyticsContext()

  return (
    <Section title="Growth & Discovery">
      <Metric
        name="Followers"
        metricName="followers_count"
        showLastSnapshotAsTotal
        period={period}
        tooltip="Followers gained or lost over time"
      />
      <Metric name="Reach" metricName="reach" period={period} tooltip="Unique accounts that viewed your posts" />
    </Section>
  )
}
